module.exports = __webpack_public_path__ + "static/media/shape_green-contact.1338373f.svg";